import { render, staticRenderFns } from "./ApiResourceList.vue?vue&type=template&id=2a7e44da&scoped=true&"
import script from "./ApiResourceList.vue?vue&type=script&lang=js&"
export * from "./ApiResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e44da",
  null
  
)

export default component.exports